import { Component,Inject,OnInit,PLATFORM_ID,Renderer2,TemplateRef,ViewChild } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup } from '@angular/forms';
import { FormBuilder,Validators } from '@angular/forms';
import { MainserviceService } from 'src/app/mainservice.service';
import Swal from 'sweetalert2';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';
import { Title, Meta } from '@angular/platform-browser';
import { SeoSocialShareService, SeoSocialShareData } from 'ngx-seo';
import { JsonLdService } from 'ngx-seo';

@Component({
  selector: 'app-allotmed',
  templateUrl: './allotmed.component.html',
  styleUrls: ['./allotmed.component.scss'],
  providers:[MainserviceService,DatePipe]
})
export class AllotmedComponent {
  enquiryForm:FormGroup;
  totalcountry:any=[];
  captcha:any
  errorcaptcha:any
  ecaptcha:boolean=false;
  dialcode:any;
  showElement: boolean = false;
  showElementsave: boolean = false;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @ViewChild('inputField') inputField!: any;
  currentTime: Date;
  timeSlots:any=[];
  timezone:any;
  appointment_time:boolean=false;
  selectedTime: string | null = null;
  leads:any;

constructor(private ngxsmartservice:NgxSmartModalService, private fb:FormBuilder,private seoService: SeoSocialShareService,private jsonLdService: JsonLdService,@Inject(PLATFORM_ID) private platformId: Object,
  private mainservice:MainserviceService,private datePipe: DatePipe,private title:Title,private meta:Meta,private renderer: Renderer2){
    this.setSeoMeta();
    if (isPlatformBrowser(this.platformId)) {

    this.setSchema();
    this.setFaqSchemaData();
  // this.title.setTitle('Efficient Wholesale Inventory Management for Pharma, Optical & More');
  //   // Add meta tags dynamically
  //   this.meta.addTag({ name: 'description', content: 'Streamline operations with our powerful software solution to maximize productivity and profits with our cutting-edge cloud technology. Get started now!' });
  //   this.meta.addTag({ name: 'keywords', content: 'wholesale inventory management, wholesale management system, wholesale inventory management software, wholesale distribution ERP software' });

  this.timezone=sessionStorage.getItem('timezone');

  this.enquiryForm=this.fb.group({
      leadname: ['',[ Validators.required]],
      organizationname: ['',[Validators.required]],
      leadsourceid: ['',[]],
      leadsource: ['medeil website',[]],
      sourceRef1: ['',[]],
      sourceRef2: ['',[]],
      description: ['',[ Validators.required]],
      primaryphone: ['',[Validators.required]],
      primaryemail: ['',[Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
      address1: ['',[]],
      address2: ['',[]],
      country: [sessionStorage.getItem('country'),[],[]],
      countryname1: ['0',[]],
      state: [sessionStorage.getItem('state'),[]],
      city: [sessionStorage.getItem('city'),[]],
      enteredcaptcha: ['',[]],
      generatedcaptcha: ['',[]],
      phonedialcode:['',[]],
      checkbox:[false,[]],
      appfrmtime:['',[]],
      apptotime:['',[]],
      appointmentdate:['',[]],
    })
  }
  }
  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: 'Allotmed: Comprehensive Distribution Management Software',
  //     description: 'Explore Allotmed, the versatile distribution management software designed to streamline your supply chain operations. Whether deployed as a cloud-based SaaS solution or on-premises, Allotmed enhances efficiency, reduces costs, and improves customer satisfaction.',
  //     image: 'https://www.medeil.com/assets/allotmed.jpg',
  //     url: 'https://www.medeil.com/allotmed-medical-supply',
  //     keywords: 'Distribution management software, Supply chain optimization, Allotmed software, Inventory tracking, Order management, Supplier management, Cloud-based distribution, On-premises deployment'
  //   };

  //   this.seoService.setData(seoData);
  // }
  setSeoMeta() {
  const supportedLanguages = ['en', 'fr', 'es', 'pt'];
  let finalUrl = '';

  if (isPlatformBrowser(this.platformId)) {
    const origin = window.location.origin;
    const path = window.location.pathname;
    const parts = path.split('/');

    let lang = 'en'; // Default
    if (supportedLanguages.includes(parts[1])) {
      lang = parts[1];
    }

    // const fullPath = path.replace(/^\/[a-z]{2}/, '');
    // finalUrl = `${origin}/${lang}${fullPath}`;
    const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

  }
    const seoData = {
      title: $localize`:@@ALLOTMED.TITLE:Allotmed: Comprehensive Distribution Management Software`,
      description: '    Allotmed, the versatile distribution management software designed to streamline your supply chain operations...',
      image: 'https://www.medeil.com/assets/allotmed.jpg',
      url: finalUrl,
      keywords: 'Distribution management software, Supply chain optimization, free supplychain management software, best supplychain management software, userfriendly supply chain management, free management software, medical supply, medical equipment, healthcare consumables, buy medical supplies online, hospital supplies, clinic equipment, AllotMED, medical products, healthcare supplies'
    };

    this.title.setTitle(seoData.title);
    const metaTags = [
      { name: 'description', content: seoData.description },
      { name: 'keywords', content: seoData.keywords },
      { property: 'og:title', content: seoData.title },
      { property: 'og:description', content: seoData.description },
      { property: 'og:url', content: seoData.url },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: seoData.image }
    ];

    metaTags.forEach(tag => this.meta.updateTag(tag));
  }

  setWebsiteSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Allotmed",
      "url": "https://www.medeil.com",
      "description": "Explore Allotmed, the versatile distribution management software designed to streamline your supply chain operations. Whether deployed as a cloud-based SaaS solution or on-premises, Allotmed enhances efficiency, reduces costs, and improves customer satisfaction.",
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "publisher": {
        "@type": "Organization",
        "name": "Medeil",
        "url": "https://www.medeil.com",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
        }
      },
    };

    this.jsonLdService.setData(schemaData);
  }
  setSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Allotmed",
      "url": "https://www.medeil.com/allotmed-medical-supply",
      "description": "Explore Allotmed, the versatile distribution management software designed to streamline your supply chain operations. Whether deployed as a cloud-based SaaS solution or on-premises, Allotmed enhances efficiency, reduces costs, and improves customer satisfaction.",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
      "image": "https://www.medeil.com/assets/allotmed.jpg",
      "offers": {
        "@type": "Offer",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock",
        "url": "https://www.medeil.com/allotmed-medical-supply",
        "keywords": "Distribution management software, Supply chain optimization, Allotmed software, Inventory tracking, Order management, Supplier management, Cloud-based distribution, On-premises deployment"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.6",
        "ratingCount": "8864"
      },
    };

    this.jsonLdService.setData(schemaData);
  }
  setFaqSchemaData() {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is software for cloud-based distribution?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "One kind of software-as-a-service (SaaS) product that helps firms automate and optimize their distribution processes is cloud-based distribution software. Instead of installing the software on local servers, customers can access it online thanks to its cloud hosting."
          }
        },
        {
          "@type": "Question",
          "name": "What distinguishing characteristics do cloud-based distribution software have?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Order management, inventory control, warehouse management, sales tracking, route optimization, reporting and analytics, supplier management, customer relationship management (CRM), and interaction with e-commerce platforms and other company systems are often considered key aspects."
          }
        },
        {
          "@type": "Question",
          "name": "What distinguishes conventional on-premises software from cloud-based distribution software?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Compared to traditional on-premises software, cloud-based distribution software has a number of benefits, such as cheaper upfront costs, quicker implementation, automated upgrades, scalability, accessibility from any location with an internet connection, and integrated disaster recovery and data backup."
          }
        },
        {
          "@type": "Question",
          "name": "How frequently are new features and upgrades for cloud-based distribution software released?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Cloud-based distribution software vendors usually deliver updates and new features on a regular basis to fix errors, enhance functionality, and adjust to evolving business requirements. Typically, updates are released automatically to guarantee that users have access to the most recent version of the program."
          }
        }
      ]
    };

    this.addJsonLdToHead(faqSchema);
  }

  addJsonLdToHead(schema: any) {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = 'faq-schema';

    // Remove old schema if it exists
    const oldScript = document.getElementById('faq-schema');
    if (oldScript) {
      oldScript.remove();
    }

    this.renderer.appendChild(document.head, script);
  }
  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {
    this.mainservice.generatecaptcha();
    this.captcha = localStorage.getItem('captcha')
     // ----country list--
     this.mainservice.getCountryList().subscribe(data=>{
       console.log(data);
       this.totalcountry=data;
     })
    }
  }
  selectedclass: number = 1;

  selectclass(index: number): void {
    this.selectedclass = index;
  }
  appointment(datasource:any){
    this.enquiryForm.get('sourceRef1').setValue(datasource);
    this.ngxsmartservice.open('enquirypos');
    // this.ngxsmartservice.open('appointmentform');
  }
  closeModal(): void {
    this.ngxsmartservice.close('enquirypos');
    this.ngxsmartservice.close('appointmentform');
    this.enquiryForm.reset();

    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  }
  countrychange(){

    this.mainservice.getMobileCode(this.enquiryForm.get('countryname1').value).subscribe((data)=>{
      //console.log(data);
      this.dialcode=data.Dailingcode;
      console.log(this.dialcode);
     // this.registerForm.get('phonedialcode').patchValue(this.dialcode[1]);
    })
  }
  checkCaptcha(){

    var usercaptcha = this.enquiryForm.get('enteredcaptcha').value

    if (this.captcha == usercaptcha) {
      this.ecaptcha = false

    } else {

      this.errorcaptcha = 'Enter correct Captcha'
      this.ecaptcha = true
    }
  }
  generatecaptcha(){
    this.mainservice.generatecaptcha()
    this.captcha = localStorage.getItem('captcha')
  }

  submitenquery(){
    let valid=this.validation();
    if(valid){
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.open('appointmentform');
      this.picker.open();
      this.inputField.focus();

    }
  }

  validation(){
    let name=this.enquiryForm.get('leadname').value
    let organizationname=this.enquiryForm.get('organizationname').value
    let primaryemail=this.enquiryForm.get('primaryemail').value
    let primaryphone=this.enquiryForm.get('primaryphone').value
    let captcha=this.enquiryForm.get('enteredcaptcha').value
    let checkbox=this.enquiryForm.get('checkbox').value

    // var usercaptcha = this.registerForm.get('enteredcaptcha').value
    if(!name){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!organizationname){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Organization Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryemail){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Email',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryphone){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Mobile Number',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(captcha != this.captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Correct Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(checkbox==false){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Select Accept & Terms condition',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }


    return true
  }

  slectdate(event: any){
    this.showElement=true;
    const selectedDate = event.value;
    const finalDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    this.enquiryForm.get('appointmentdate').setValue(finalDate);
   this.currentTime = new Date();

   let map={
    "timezone":this.timezone,
    "orginaltimezone":this.currentTime
  }
  this.mainservice.gettimeSlots(map).subscribe(data=>{
    this.timeSlots = data[0].map((time:any)=> {
      const [hours, minutes] = time.split(':');
      const hours12 = ((parseInt(hours) + 11) % 12) + 1;
      const ampm = parseInt(hours) < 12 ? 'AM' : 'PM';
      return `${hours12}:${minutes} ${ampm}`;
    });
    this.showElement=false;
    console.log(this.timeSlots);
  })

    this.appointment_time=true;
  }
  selectTime(time: string): void {
    const currentTime = new Date();
    const formattedTime = this.datePipe.transform(currentTime, 'hh:mm:ss a');
    console.log(formattedTime);
    this.selectedTime = time;
    // this.enquiryForm.get('apptotime').setValue(time);
    this.enquiryForm.get('appfrmtime').setValue(time);

  }
  savelead(){
    this.showElementsave=true;

    // if (valid) {

      let phone = this.enquiryForm.get('primaryphone').value

      let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
      this.enquiryForm.get('primaryphone').setValue(mobileno)

       console.log('form',this.enquiryForm.value);

  this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
    this.leads = data
    // console.log("this.leads",this.leads)
    if (data) {
      // this.enquiryForm.reset()
      // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
      this.enquiryForm.reset();
      this.showElementsave=false;
      // this.submitenquery();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Data saved successfully',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 4000
      });
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.close('appointmentform');
      this.enquiryForm.reset();
    }
     else{
      this.enquiryForm.get('primaryphone').setValue(phone);
      // this.showElement=false;
    }
    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  })

  }
  closepopup(){
    this.ngxsmartservice.close('myModal');
    this.enquiryForm.reset();

    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  }
  trynowbtn(data:any){
    // this.enquiryForm.reset();
    this.enquiryForm.get('sourceRef1').setValue(data);
    this.ngxsmartservice.open('myModal');
    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();

  }
  savesignup(){


    let valid=this.validation();

    if (valid) {
      this.showElement=true;
      let phone = this.enquiryForm.get('primaryphone').value

      let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
      this.enquiryForm.get('primaryphone').setValue(mobileno)

       console.log('form',this.enquiryForm.value);

    this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
    this.leads = data
    // console.log("this.leads",this.leads)
    if (data) {
      // this.enquiryForm.reset()
      // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
      this.enquiryForm.reset();
      this.showElement=false;
      // this.submitenquery();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Data saved successfully',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 4000
      });
      this.ngxsmartservice.close('myModal');
    }
     else{
      this.enquiryForm.get('primaryphone').setValue(phone);
      this.showElement=false;
    }
  })

    }
    else{
      this.showElement=false;
    }

    this.enquiryForm.get('countryname1').setValue('0');
    this.generatecaptcha();
  }
  broucher(data:any){
    this.enquiryForm.get('sourceRef1').setValue(data);
    this.ngxsmartservice.open('myModal1');
  }
  savebroucher() {
    let valid = this.validation();


    if (valid) {
      this.showElementsave = true;
      let phone = this.enquiryForm.get('primaryphone').value;
      let mobileno = this.enquiryForm.get('phonedialcode').value + this.enquiryForm.get('primaryphone').value;
      this.enquiryForm.get('primaryphone').setValue(mobileno);

      console.log('form', this.enquiryForm.value);

      this.mainservice.savelead(this.enquiryForm.value).subscribe(
        (data: any) => {

          this.leads = data;

          if (data) {
            this.enquiryForm.reset();
            this.showElementsave = false;
            Swal.fire({
              title: "Do you want to view the Brochure?",
              // showDenyButton: true,
              // showCancelButton: true,
              confirmButtonText: "yes",

            }).then((result) => {

              if (result.isConfirmed) {

            const url = 'https://medeilpos.blob.core.windows.net/websitedocuments/medeilcloudposbrochure.pdf';
            window.open(url, '_blank');
              }
            });
            this.ngxsmartservice.close('myModal1');


          } else {
            this.enquiryForm.get('primaryphone').setValue(phone);
            this.showElement = false;
          }

          this.enquiryForm.get('countryname1').setValue('0');
          this.generatecaptcha();
        },
        (error: any) => {
          console.error('Error saving form', error);
          this.enquiryForm.get('primaryphone').setValue(phone);
          this.showElement = false;
        }
      );
    } else {
      this.showElement = false;
    }
  }
}
